<template>
<div class="chapter">
<div class="inner_page">
<h1>The Margaret Kerr Series</h1>
<h3 class="sigil_not_in_toc"><i>A Trust Betrayed<br/>
  The Fire in the Flint<br/>
  A Cruel Courtship</i></h3>
<h3 class="sigil_not_in_toc">Candace Robb</h3>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0001.vue?1a47da2a